export default "__VITE_ASSET__DHPqpRfp__"